module.exports = __webpack_public_path__ + "img/tech-stack.0d8259c8.png";